import Text from '@atoms/Text/Text';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import { useState } from 'react';
import { RegisterOptions, useFormContext } from 'react-hook-form';

export interface IHCaptchaField {
  name: string;
  siteKey: string;
  registerOptions: RegisterOptions;
}

const HCaptchaField = ({
  name,
  siteKey,
  registerOptions,
}: Readonly<IHCaptchaField>) => {
  const [verified, setVerified] = useState(false);
  const { register, formState, setValue } = useFormContext();
  const error = formState.errors[name];
  const errorMessage =
    typeof error?.message === 'string' && !verified ? error.message : '';

  const onVerify = (verificationToken: string) => {
    setVerified(true);
    setValue(name, verificationToken);
  };

  return (
    <div>
      <HCaptcha sitekey={siteKey} onVerify={onVerify} />
      <input
        type="checkbox"
        className="tw-hidden"
        checked={verified}
        {...register(name, registerOptions)}
      />
      {errorMessage && (
        <Text variant="label-12" className="tw-text-red" role="alert">
          {errorMessage}
        </Text>
      )}
    </div>
  );
};

export default HCaptchaField;
